import React from "react";
import { HiChevronRight } from "react-icons/hi";

const CorporateBreadcrumb = ({ items = [] }) => {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" className="overflow-hidden">
      <ol className="flex flex-nowrap items-center gap-2 overflow-hidden text-xs font-semibold uppercase tracking-[0.4em] text-gray-500 whitespace-nowrap">
        {items.map((item, index) => (
          <li
            key={`${item.label}-${index}`}
            className="flex min-w-0 items-center gap-2"
          >
            <span className="flex min-w-0 items-center gap-2 text-[0.65rem] leading-none">
              {item.href && !item.current ? (
                <a
                  href={item.href}
                  className="block truncate text-[#FE731B] transition hover:text-indigo-900"
                >
                  {item.label}
                </a>
              ) : (
                <span className="block truncate text-gray-700">
                  {item.label}
                </span>
              )}
            </span>
            {index < items.length - 1 && (
              <HiChevronRight className="h-4 w-4 text-indigo-200" />
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default CorporateBreadcrumb;
